import * as React from 'react'
import { useSelector } from 'react-redux'
import { useCreateOppActions } from './reducer'
import { LocationsTable, ServiceLocationsDrawer } from './atoms'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { useGetUserBranchListOnMount } from '@user/store/authorization/hooks/useGetUserBranchListOnMount'
import { useSearchServiceLocations } from '@user/store/entityLocations'
import { SelectLocationsHeader } from './SelectLocationsHeader'
import { SettingsPage } from '@sales-center/components'

type Props = ReturnType<typeof useCreateOppActions> & {
  fullScreen?: boolean
}

export function SelectLocations(props: Props) {
  const { onClickCreateOpp, fullScreen } = props

  const currentUser = useSelector(selectCurrentUser)

  const branchListLoadStatus = useGetUserBranchListOnMount()

  const branchIds = React.useMemo(
    () => (currentUser.isAdmin ? '' : currentUser.branches?.map((b) => b.id)),
    [currentUser.branches, currentUser.isAdmin],
  )

  const svcLocSearchState = useSearchServiceLocations('', 50, branchIds)

  const branchesLoading = branchListLoadStatus === 'pending'

  return (
    <SettingsPage
      fullScreen={fullScreen}
      title="Create Opportunity"
      padding="0"
      headContent={
        <SelectLocationsHeader svcLocSearchState={svcLocSearchState} />
      }
    >
      <LocationsTable
        searchState={svcLocSearchState}
        branchesLoading={branchesLoading}
        onClickCreateOpp={onClickCreateOpp}
      />

      <ServiceLocationsDrawer {...props} />
    </SettingsPage>
  )
}
